
var modalButtons = document.querySelectorAll(".modal-toggle");

if (modalButtons) {
    modalButtons.forEach((modalButton) => {
        modalButton.addEventListener("click", handleModal);
    });
}

function handleModal(e) {
    // handle updating modal content
    const opener = e.target.closest('[data-modal-target]');
    const modalContentId = opener.dataset.modalTarget;
    const modalContent = document.querySelector("#" + modalContentId);
    var isSmall = modalContent.dataset.modalSize === "small";
    const modalContentClone = modalContent.cloneNode(true);
    modalContentClone.classList.remove("hidden");
    modalContentClone.setAttribute("id", "");
    const modal = document.getElementById("modal");
    const ariaLabelText = modalContent.querySelector(".modalInfoText").textContent;
    modal.setAttribute("aria-label", ariaLabelText);
    const contentContainer = document.getElementById("modalPlaceholder");
    contentContainer.innerHTML = "";
    contentContainer.appendChild(modalContentClone);

    // handle showing modal
    const bootstrapModal = new bootstrap.Modal('#modal');
    bootstrapModal.show(opener);

    const modalElement = document.getElementById('modal');
    if (isSmall) {
        modalElement.classList.add("modal--small");
    }
    modalElement.addEventListener('hidden.bs.modal', () => {
        // focus on the modal toggle
        opener.focus();
    });
}
